import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { theme } from "../../common/style/Theme";

const Typewriter = () => {
    const phrases = ["Smart Technology", "Seamless Synergy", "Scalable Success"];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [displayText, setDisplayText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [fontSize, setFontSize] = useState('2.1rem');
  
    const typeSpeed = 125;   // ms per character when typing
    const deleteSpeed = 125; // ms per character when deleting
    const pauseTime = 1000;  // pause after full phrase

    // Responsive font sizing
    useEffect(() => {
      const updateFontSize = () => {
        const width = window.innerWidth;
        let newFontSize;
        
        if (width < 600) { // Mobile
          newFontSize = '1.2rem';
        } else if (width < 900) { // Tablet
          newFontSize = '1.6rem';
        } else if (width < 1200) { // Small desktop
          newFontSize = '1.8rem';
        } else { // Large desktop
          newFontSize = '2.1rem';
        }
        
        setFontSize(newFontSize);
      };

      updateFontSize();
      window.addEventListener('resize', updateFontSize);
      
      return () => window.removeEventListener('resize', updateFontSize);
    }, []);
  
    useEffect(() => {
      const currentPhrase = phrases[currentIndex];
      let timeoutId;
  
      if (!isDeleting && displayText.length < currentPhrase.length) {
        // Typing: add next character
        timeoutId = setTimeout(() => {
          setDisplayText(currentPhrase.substring(0, displayText.length + 1));
        }, typeSpeed);
      } else if (!isDeleting && displayText.length === currentPhrase.length) {
        // Finished typing; pause then start deleting
        timeoutId = setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && displayText.length > 0) {
        // Deleting: remove last character
        timeoutId = setTimeout(() => {
          setDisplayText(currentPhrase.substring(0, displayText.length - 1));
        }, deleteSpeed);
      } else if (isDeleting && displayText.length === 0) {
        // Finished deleting; move to next phrase
        setIsDeleting(false);
        setCurrentIndex((currentIndex + 1) % phrases.length);
      }
  
      return () => clearTimeout(timeoutId);
      // eslint-disable-next-line
    }, [displayText, isDeleting, currentIndex]);
  
    return (
      <Box className="typewriter-container">
        <Typography variant="h3" style={{
            color: theme.palette.common.white,
            fontWeight: 700,
            fontSize: fontSize,
            lineHeight: 1.2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        }}>
          <span style={{
            whiteSpace: 'nowrap',
            display: 'block',
            marginBottom: '0.5rem',
          }}>
            Empowering Business Transformation
          </span>
          <span style={{
            whiteSpace: 'nowrap',
            display: 'block',
            minHeight: '1.2em',
          }}>
            through 
            <span style={{
              fontFamily: "'Montserrat', serif",
              fontWeight: 700,
              color: theme.palette.secondary.main,
              marginLeft: "10px",
              whiteSpace: "nowrap",
            }}>{displayText}</span>
            <span className="cursor" style={{
              fontFamily: "'Montserrat', serif",
              fontWeight: 700,
              color: theme.palette.secondary.main,
              marginLeft: "10px",
              whiteSpace: "nowrap",
            }}>|</span>
          </span>
        </Typography>
      </Box>
    );
  };
  
  export default Typewriter;